"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbEditableList = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _sortBy = _interopRequireDefault(require("lodash/sortBy"));

var _v = _interopRequireDefault(require("uuid/v4"));

var _reactIntl = require("react-intl");

var _shapes = require("../../skybase-core/shapes");

var _sbButton = require("../sb-button/sb-button");

var _sbTextbox = require("../sb-textbox");

var _sbIpv4Input = require("../sb-ipv4-input");

var _sbIpv6Input = require("../sb-ipv6-input");

var _propTypeMessage = require("../../skybase-core/shapes/prop-type-message");

var _value = require("../../skybase-core/utils/value");

var _constants = require("./constants");

var _utils = require("./utils");

var _sbEditableListI18n = require("./sb-editable-list-i18n");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DISABLED = _constants.itemControls.DISABLED,
    HIDDEN = _constants.itemControls.HIDDEN;
/**
 * @desc
 * Editable list component that allows to move items up and down and add/remove them.
 *
 * @public
 *
 */

var _SbEditableList = /*#__PURE__*/function (_React$Component) {
  _inherits(_SbEditableList, _React$Component);

  var _super = _createSuper(_SbEditableList);

  function _SbEditableList(props) {
    var _this;

    _classCallCheck(this, _SbEditableList);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleOnUpDown", function (positionIndex, increment) {
      var allItems = _this.state.allItems; // Guard against moving outside of the list

      if (positionIndex === 0 && increment === _constants.movementIncrement.MOVE_UP || positionIndex === allItems.length - 1 && increment === _constants.movementIncrement.MOVE_DOWN) {
        return;
      }

      var shiftedItems = (0, _utils.shiftValues)({
        allItems: allItems,
        item1: allItems[positionIndex],
        item2: allItems[positionIndex + increment]
      });
      var sortedItems = (0, _sortBy.default)(shiftedItems, function (sortingItem) {
        return sortingItem.positionIndex;
      });

      _this.handleOnChange(sortedItems);
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnDelete", function (event, positionIndex) {
      event.preventDefault();
      var allItems = _this.state.allItems;
      var filteredItems = allItems.filter(function (item) {
        return item.positionIndex !== positionIndex;
      }); // remove item

      var sortedItems = (0, _sortBy.default)(filteredItems, function (sortingItem) {
        return sortingItem.positionIndex;
      }); // sort by positionIndex - to be sure

      _this.handleOnChange(sortedItems);
    });

    _defineProperty(_assertThisInitialized(_this), "handleItemAdd", function (event) {
      event.preventDefault();
      var _this$props = _this.props,
          newItemValue = _this$props.newItemValue,
          onNewItem = _this$props.onNewItem,
          autoFocusNewItem = _this$props.autoFocusNewItem;
      var items = _this.state.items;
      var resultItems = (0, _utils.addItem)({
        items: items,
        value: newItemValue
      });

      if (autoFocusNewItem) {
        _this.newElementAutoFocused = true;
      }

      _this.handleOnChange(resultItems);

      onNewItem();
    });

    _defineProperty(_assertThisInitialized(_this), "handleItemUpdate", function (positionIndex, newValue) {
      _this.newElementAutoFocused = false;
      var allItems = _this.state.allItems;
      var resultItems = (0, _utils.updateItem)({
        positionIndex: positionIndex,
        allItems: allItems,
        newValue: newValue
      });

      _this.handleOnChange(resultItems);
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (updatedItems) {
      var onChange = _this.props.onChange;
      var allItems = _this.state.allItems;
      var items = (0, _value.isNullOrUndefined)(updatedItems) ? allItems : updatedItems;
      onChange((0, _utils.removeIndexes)(items), _this.newElementAutoFocused);
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputsBlur", function () {
      _this.newElementAutoFocused = false;
      var onBlur = _this.props.onBlur;
      onBlur();
    });

    _defineProperty(_assertThisInitialized(_this), "renderInputByType", function (item, type, autoFocus) {
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          id = _this$props2.id,
          itemValueFilter = _this$props2.itemValueFilter,
          placeholder = _this$props2.placeholder;

      var value = item.value,
          positionIndex = item.positionIndex,
          rest = _objectWithoutProperties(item, ["value", "positionIndex"]);

      var IPv4 = _constants.inputTypes.IPv4,
          IPv6 = _constants.inputTypes.IPv6;
      var inputId = id ? "".concat(id, "-input-").concat(positionIndex) : null;

      if (type === IPv4) {
        return /*#__PURE__*/_react.default.createElement(_sbIpv4Input.SbIpV4Input, _extends({}, rest, {
          className: "sb-width-100pct",
          id: inputId,
          value: value || '',
          onChange: function onChange(ipv4Value) {
            return _this.handleItemUpdate(positionIndex, ipv4Value);
          },
          onBlur: _this.handleInputsBlur,
          disabled: disabled,
          autoFocus: autoFocus,
          placeholder: placeholder
        }));
      }

      if (type === IPv6) {
        return /*#__PURE__*/_react.default.createElement(_sbIpv6Input.SbIpV6Input, _extends({}, rest, {
          className: "sb-width-100pct",
          id: inputId,
          value: value || '',
          onChange: function onChange(ipv4Value) {
            return _this.handleItemUpdate(positionIndex, ipv4Value);
          },
          onBlur: _this.handleInputsBlur,
          disabled: disabled,
          autoFocus: autoFocus,
          placeholder: placeholder
        }));
      }

      return /*#__PURE__*/_react.default.createElement(_sbTextbox.SbTextbox, _extends({}, rest, {
        className: "sb-width-100pct",
        id: inputId,
        value: value || '',
        onBlur: function onBlur(event) {
          _this.handleItemUpdate(positionIndex, event.target.value);

          _this.handleInputsBlur(event);
        },
        onChange: function onChange(event) {
          _this.handleItemUpdate(positionIndex, event.target.value);
        },
        filterValue: itemValueFilter,
        disabled: disabled,
        autoFocus: autoFocus,
        placeholder: placeholder
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "onItemDragEnd", function (event) {
      event.preventDefault();

      _this.setState({
        draggingTargetPosition: null,
        draggingItem: null
      });

      _this.handleOnChange();
    });

    _defineProperty(_assertThisInitialized(_this), "onItemDragOver", function (event, item) {
      var _this$state = _this.state,
          draggingItem = _this$state.draggingItem,
          draggingTargetPosition = _this$state.draggingTargetPosition,
          allItems = _this$state.allItems;

      if ((0, _value.isNullOrUndefined)(draggingTargetPosition)) {
        // if there is no draggingTarget in state, then set the current item.
        _this.setState({
          draggingTargetPosition: item.positionIndex
        });
      } else if (draggingTargetPosition !== item.positionIndex && item.positionIndex !== draggingItem.positionIndex) {
        // if there is the draggingTarget in state and it's different from the draggingItem, then swap it.
        var shiftedItems = (0, _utils.shiftValues)({
          allItems: allItems,
          item1: draggingItem,
          item2: item
        });
        var sortedItems = (0, _sortBy.default)(shiftedItems, function (sortingItem) {
          return sortingItem.positionIndex;
        });

        _this.setState({
          allItems: sortedItems,
          draggingTargetPosition: item.positionIndex,
          draggingItem: _objectSpread(_objectSpread({}, draggingItem), {}, {
            positionIndex: item.positionIndex
          })
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onItemDrag", function (event, item) {
      var draggingItem = _this.state.draggingItem;

      if (!draggingItem) {
        var newDraggingItem = _objectSpread(_objectSpread({}, item), {}, {
          isMoving: true
        });

        _this.setState({
          draggingItem: newDraggingItem
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDragStart", function (e) {
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('text/html', e.target.parentNode);
      e.dataTransfer.setDragImage(e.target.parentNode, 20, 20);
    });

    _defineProperty(_assertThisInitialized(_this), "createItemIcons", function (options) {
      var positionIndex = options.positionIndex,
          fixedCount = options.fixedCount,
          upButtonId = options.upButtonId,
          downButtonId = options.downButtonId,
          removeButtonId = options.removeButtonId,
          moveUpClass = options.moveUpClass,
          moveDownClass = options.moveDownClass,
          deleteClass = options.deleteClass,
          canBeDragged = options.canBeDragged,
          isArrowDisabled = options.isArrowDisabled,
          isRemoveDisabled = options.isRemoveDisabled,
          isArrowHidden = options.isArrowHidden,
          isRemoveHidden = options.isRemoveHidden;
      var disableUp = moveUpClass.indexOf(_constants.DISABLED_ITEM_CLASS) !== -1;
      var disableDown = moveDownClass.indexOf(_constants.DISABLED_ITEM_CLASS) !== -1;
      var draggableSymbol = canBeDragged ? /*#__PURE__*/_react.default.createElement("span", {
        className: "sbi-drag-indicator dragging-icon",
        draggable: canBeDragged,
        onDragStart: _this.onDragStart
      }) : null;
      var moveUpSymbol = isArrowHidden ? null : /*#__PURE__*/_react.default.createElement("div", {
        className: moveUpClass,
        onClick: disableUp || isArrowDisabled ? null : function () {
          return _this.handleOnUpDown(positionIndex, _constants.movementIncrement.MOVE_UP);
        },
        id: upButtonId
      });
      var moveDownSymbol = isArrowHidden ? null : /*#__PURE__*/_react.default.createElement("div", {
        className: moveDownClass,
        onClick: disableDown || isArrowDisabled ? null : function () {
          return _this.handleOnUpDown(positionIndex, _constants.movementIncrement.MOVE_DOWN);
        },
        id: downButtonId
      }); // OnMousedown prevented so that blur happens after click.

      var deleteSymbol = fixedCount || isRemoveHidden ? null : /*#__PURE__*/_react.default.createElement("div", {
        className: deleteClass,
        onMouseDown: function onMouseDown(event) {
          return event.preventDefault();
        },
        onClick: isRemoveDisabled ? null : function (event) {
          return _this.handleOnDelete(event, positionIndex);
        },
        id: removeButtonId
      });
      return {
        draggableSymbol: draggableSymbol,
        moveUpSymbol: moveUpSymbol,
        moveDownSymbol: moveDownSymbol,
        deleteSymbol: deleteSymbol
      };
    });

    _this.newElementAutoFocused = false;
    _this.state = {
      allItems: (0, _utils.copyItems)(props.items),
      items: (0, _utils.copyItems)(props.items)
    };
    _this.instanceID = (0, _v.default)();
    return _this;
  }
  /*
  This function is triggered before every (re)render, unlike willReceiveProps (which only after props changing).
  Therefore, standard lodash isEqual does not work due to having a custom `positionIndex` on the `prevState` items (always returning false).
  There is a custom function needed, that extract those indexes and after that use lodash isEqual.
   */


  _createClass(_SbEditableList, [{
    key: "renderItems",
    value: function renderItems() {
      var _this2 = this;

      var _this$props3 = this.props,
          inputType = _this$props3.inputType,
          id = _this$props3.id,
          itemLabel = _this$props3.itemLabel,
          draggable = _this$props3.draggable,
          fixedCount = _this$props3.fixedCount,
          autoFocusNewItem = _this$props3.autoFocusNewItem,
          disabled = _this$props3.disabled,
          _this$props3$controls = _this$props3.controls,
          arrows = _this$props3$controls.arrows,
          remove = _this$props3$controls.remove;
      var _this$state2 = this.state,
          allItems = _this$state2.allItems,
          draggingItem = _this$state2.draggingItem;
      var isMovingClassName = 'li-is-moving';
      var canBeDragged = draggable && !disabled;
      var itemsLength = allItems.length;

      var _extractItemsControls = (0, _utils.extractItemsControlsVisibility)({
        arrows: arrows,
        remove: remove,
        disabled: disabled
      }),
          isArrowDisabled = _extractItemsControls.isArrowDisabled,
          isArrowHidden = _extractItemsControls.isArrowHidden,
          isRemoveDisabled = _extractItemsControls.isRemoveDisabled,
          isRemoveHidden = _extractItemsControls.isRemoveHidden;

      return allItems.map(function (item, idx) {
        var positionIndex = item.positionIndex;
        var autoFocus = idx === itemsLength - 1 && autoFocusNewItem && _this2.newElementAutoFocused;

        var _extractItemParams = (0, _utils.extractItemParams)({
          item: item,
          allItems: allItems,
          id: id
        }),
            upButtonId = _extractItemParams.upButtonId,
            downButtonId = _extractItemParams.downButtonId,
            removeButtonId = _extractItemParams.removeButtonId;

        var _extractItemClasses = (0, _utils.extractItemClasses)({
          item: item,
          draggingItem: draggingItem,
          positionIndex: positionIndex,
          allItems: allItems,
          isMovingClassName: isMovingClassName,
          isArrowDisabled: isArrowDisabled,
          isRemoveDisabled: isRemoveDisabled
        }),
            itemClass = _extractItemClasses.itemClass,
            moveUpClass = _extractItemClasses.moveUpClass,
            moveDownClass = _extractItemClasses.moveDownClass,
            deleteClass = _extractItemClasses.deleteClass;

        var _this2$createItemIcon = _this2.createItemIcons({
          positionIndex: positionIndex,
          itemsLength: itemsLength,
          fixedCount: fixedCount,
          upButtonId: upButtonId,
          downButtonId: downButtonId,
          removeButtonId: removeButtonId,
          moveUpClass: moveUpClass,
          moveDownClass: moveDownClass,
          deleteClass: deleteClass,
          canBeDragged: canBeDragged,
          isArrowDisabled: isArrowDisabled,
          isRemoveDisabled: isRemoveDisabled,
          isArrowHidden: isArrowHidden,
          isRemoveHidden: isRemoveHidden
        }),
            draggableSymbol = _this2$createItemIcon.draggableSymbol,
            moveUpSymbol = _this2$createItemIcon.moveUpSymbol,
            moveDownSymbol = _this2$createItemIcon.moveDownSymbol,
            deleteSymbol = _this2$createItemIcon.deleteSymbol;

        return /*#__PURE__*/_react.default.createElement("li", {
          className: itemClass,
          key: "edit-list-".concat(_this2.instanceID, "-").concat(positionIndex),
          onDrag: function onDrag(event) {
            return _this2.onItemDrag(event, item);
          },
          onDragEnd: function onDragEnd(event) {
            return _this2.onItemDragEnd(event, item);
          },
          onDragOver: function onDragOver(event) {
            return _this2.onItemDragOver(event, item);
          }
        }, draggableSymbol, /*#__PURE__*/_react.default.createElement("span", null, itemLabel), _this2.renderInputByType(item, inputType, autoFocus), moveUpSymbol, moveDownSymbol, deleteSymbol);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          className = _this$props4.className,
          id = _this$props4.id,
          disabled = _this$props4.disabled,
          style = _this$props4.style,
          fixedCount = _this$props4.fixedCount,
          addButtonLabel = _this$props4.addButtonLabel,
          add = _this$props4.controls.add,
          _ = _this$props4.intl.formatMessage;
      var wrapperClass = (0, _classnames.default)('sb-editable-list', {
        disabled: disabled
      }, className);
      var addButtonId = id ? "".concat(id, "-addItemButton") : null; // OnMousedown prevented so that blur happens after click.

      var addItemButton = null; // the item count is not frozen && controls.add is either undefined (omitted when defining custom controls) or it is not HIDDEN at least ...

      if (!fixedCount && (!add || add.toLowerCase() !== HIDDEN)) {
        var isDisabled = disabled;

        if (add) {
          isDisabled = add.toLowerCase() === DISABLED;
        }

        addItemButton = /*#__PURE__*/_react.default.createElement(_sbButton.SbButton, {
          onMouseDown: function onMouseDown(event) {
            return event.preventDefault();
          },
          onClick: this.handleItemAdd,
          disabled: isDisabled,
          id: addButtonId,
          className: "sb-btn-with-icon-text"
        }, /*#__PURE__*/_react.default.createElement("i", {
          className: "sbi-plus"
        }), addButtonLabel || _(_sbEditableListI18n.messages.addNewItem));
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: wrapperClass,
        id: id,
        style: style
      }, /*#__PURE__*/_react.default.createElement("ul", null, this.renderItems()), /*#__PURE__*/_react.default.createElement("div", {
        className: "fl-row"
      }, /*#__PURE__*/_react.default.createElement("div", null, addItemButton)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var prevItems = prevState.items;
      var nextItems = nextProps.items;

      if (!(0, _utils.compareItems)({
        prevItems: prevItems,
        nextItems: nextItems
      })) {
        return {
          allItems: (0, _utils.copyItems)(nextItems),
          items: (0, _utils.copyItems)(nextItems),
          allItemsLastConfig: (0, _utils.copyItems)(nextItems),
          draggingItem: null,
          draggingTargetPosition: null
        };
      }

      return null;
    }
    /*
    Handler on ArrowUp and ArrowDown buttons.
     */

  }]);

  return _SbEditableList;
}(_react.default.Component);

_defineProperty(_SbEditableList, "propTypes", {
  addButtonLabel: _propTypes.default.oneOfType([_propTypes.default.string, _propTypeMessage.PropTypeMessage]),
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  id: _propTypes.default.string,
  inputType: _propTypes.default.string,
  items: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  itemValueFilter: _propTypes.default.func,
  itemLabel: _propTypes.default.node,
  newItemValue: _propTypes.default.string,
  onChange: _propTypes.default.func.isRequired,
  onBlur: _propTypes.default.func,
  onNewItem: _propTypes.default.func,
  intl: _shapes.intlShape.isRequired,
  style: _propTypes.default.object,
  // eslint-disable-line
  draggable: _propTypes.default.bool,
  disableMoveControls: _propTypes.default.bool,
  fixedCount: _propTypes.default.bool,
  autoFocusNewItem: _propTypes.default.bool,
  controls: _propTypes.default.object,
  // eslint-disable-line
  placeholder: _propTypes.default.string
});

_defineProperty(_SbEditableList, "defaultProps", {
  addButtonLabel: null,
  className: null,
  disabled: false,
  id: null,
  inputType: _constants.inputTypes.DEFAULT,
  itemValueFilter: function itemValueFilter() {
    return true;
  },
  itemLabel: '',
  newItemValue: '',
  onBlur: function onBlur() {},
  onNewItem: function onNewItem() {},
  style: null,
  draggable: true,
  disableMoveControls: false,
  fixedCount: false,
  autoFocusNewItem: true,
  controls: {},
  placeholder: null
});

var SbEditableList = (0, _reactIntl.injectIntl)(_SbEditableList);
exports.SbEditableList = SbEditableList;
//# sourceMappingURL=sb-editable-list.js.map